import napStyles from './../nap.json'

export default {
  color: napStyles.colors.PrimaryBlack,
  lineColor: napStyles.colors.SecondaryGreySteel,
  fontFamily: 'SackersGothicStd, sans-serif',
  fontWeight: '1000',
  fontSize: '12px',
  loyaltyFontStyle: {
    fontFamily: 'ChronicleText, Georgia, Serif, sans-serif',
    fontWeight: '325',
    fontSize: '16px',
    lineHeight: '24px'
  }
}
